/* eslint-disable react/prop-types */
import React from "react";
import { TableCell, TableRow } from "@mui/material";
import Table from "../../../../components/common/new/Table/Table";
import Typography from "../../../../components/common/new/Typography/Typography";

const tableHeadCells = {
  color: "#000000",
  fontWeight: 600,
  background: "#BAD9EC",
};

const typoghrphyStyle = {
  color: "rgba(0, 0, 0, 0.87)",
  fontSize: "0.875rem",
};

const tabelCellWidth = {
  tiny: {
    maxWidth: "3.5rem",
  },
  small: {
    maxWidth: "6rem",
  },
  medium: {
    maxWidth: "10rem",
  },
  large: {
    maxWidth: "25rem",
  },
};

const COLUMNS = [
  {
    displayName: "S.No",
    key: "s.no",
  },
  {
    displayName: "Member ID",
    key: "memberId",
  },
  {
    displayName: "Name",
    key: "name",
  },
  {
    displayName: "Previous Position",
    key: "previousPosition",
  },
  {
    displayName: "Remark",
    key: "remark",
  },
  {
    displayName: "Org Structure",
    key: "orgStructure",
  },
];

const getRows = ({ searchData }) =>
  searchData.map((row, index) => {
    const serialNumber = index + 1;
    const memberName = row?.memberDetails?.fullName || "-";

    const orgParts = [
      row?.currentAreaName,
      row?.currentClusterName,
      row?.currentZoneName,
      row?.currentRegionName,
      row?.currentChapterName,
      row?.currentDistrictName,
      row?.currentBlockName,
    ].filter(Boolean);

    return (
      <TableRow key={row?.id ?? `${row?.memberId}-${index}`}>
        <TableCell style={tabelCellWidth.tiny}>
          <Typography style={typoghrphyStyle}>{serialNumber}</Typography>
        </TableCell>
        <TableCell style={tabelCellWidth.medium}>
          <Typography style={typoghrphyStyle}>
            {row?.memberId ?? "-"}
          </Typography>
        </TableCell>
        <TableCell style={tabelCellWidth.large}>
          <Typography style={typoghrphyStyle}>{memberName}</Typography>
        </TableCell>
        <TableCell style={tabelCellWidth.large}>
          <Typography style={typoghrphyStyle}>
            {row?.appliedForName || "-"}
          </Typography>
        </TableCell>
        <TableCell style={tabelCellWidth.large}>
          <Typography style={typoghrphyStyle}>{row?.remark || "-"}</Typography>
        </TableCell>
        <TableCell style={tabelCellWidth.large}>
          <Typography style={typoghrphyStyle}>
            {orgParts.length ? orgParts.join(" / ") : "-"}
          </Typography>
        </TableCell>
      </TableRow>
    );
  });

function ReportTable({ searchData }) {
  return (
    <Table
      scrollable
      columns={COLUMNS}
      rows={getRows({ searchData })}
      tableBodyTheme="#F6F6F6"
      tableHeadCellStyle={{
        ...tableHeadCells,
        textAlign: "center",
      }}
    />
  );
}

export default ReportTable;
